import { View } from "react-native";
import { StyleSheet } from "react-native";
import WebView from "react-native-webview";
import useResponsiveScreen from "../../hooks/useResponsiveScreen";

type YoutubeVideoPlayerAdvancedProps = {
  id: string;
  timestamp?: number;
  /** When true, the iframe loads with autoplay + playsinline so the user doesn't have to click play inside the embed. */
  autoplay?: boolean;
};

const YoutubeVideoPlayerAdvanced = ({ id, timestamp, autoplay = false }: YoutubeVideoPlayerAdvancedProps) => {
  const { isMedium } = useResponsiveScreen();

  const params = new URLSearchParams();
  if (timestamp) params.set("start", String(timestamp));
  if (autoplay) {
    params.set("autoplay", "1");
    params.set("playsinline", "1");
  }
  const query = params.toString();
  const videoUrl = query ? `https://www.youtube.com/embed/${id}?${query}` : `https://www.youtube.com/embed/${id}`;

  return (
    <View style={!isMedium ? styles.mobileVideoContainer : styles.videoContainer}>
      <WebView
        style={styles.webView}
        source={{
          uri: videoUrl,
        }}
        javaScriptEnabled={true}
        allowsFullscreenVideo={true}
      />
    </View>
  );
};

export default YoutubeVideoPlayerAdvanced;

const styles = StyleSheet.create({
  videoContainer: {
    width: "100%",
    aspectRatio: 16 / 9,
    overflow: "hidden",
  },
  mobileVideoContainer: {
    width: "100%",
    aspectRatio: 16 / 9,
    overflow: "hidden",
  },
  webView: {
    width: "100%",
    height: "100%",
  },
});
